module.exports = __webpack_public_path__ + "static/silvanus-symbol-DND3_FnP-085832cf19931ec67d6ef9a360074f4d.jpg";